import {
  Paper,
  styled,
  Table,
  TableBody,
  TableContainer,
  Typography,
} from "@mui/material";
import { GeoJSON, Map } from "leaflet";
import { useTranslation } from "react-i18next";

import { DrawState, DrawType, MeasureConf } from "types/types";

import { ActiveMeasureConfigPointItem } from "./ActiveMeasureConfigPointItem";
import { ActiveMeasureConfigPolyItem } from "./ActiveMeasureConfigPolyItem";

interface Props {
  mapRef: Map;
  measureConfigurations: MeasureConf[];
  basePolygon: GeoJSON;
  measureConfigId: number;
  minArea: number;
  drawState: DrawState;
  removeLayerFromMeasureConfig: (layerId: number) => void;
  updateMeasureConfigurations: (updatedMeasureConfigs: MeasureConf[]) => void;
  updateDrawState: (drawType?: DrawType) => void;
}

export function ActiveMeasureConfigs(props: Props) {
  const {
    measureConfigurations,
    mapRef,
    basePolygon,
    measureConfigId,
    minArea,
    drawState,
    removeLayerFromMeasureConfig,
    updateMeasureConfigurations,
    updateDrawState,
  } = props;

  const { t } = useTranslation();

  const measureConfiguration = measureConfigurations.find(
    (measureConfig) => measureConfig.id === measureConfigId
  );

  return (
    <StyledPaper elevation={0}>
      {(!measureConfiguration || measureConfiguration?.layers.length === 0) && (
        <Typography>{t("label.noMeasuresDrawnYet")}</Typography>
      )}
      <TableContainer>
        <Table>
          <TableBody>
            {measureConfiguration &&
              measureConfiguration.layers.length > 0 &&
              measureConfiguration.layers.map((layer, i) => {
                if (measureConfiguration.measure.geometryType === "POLYGON")
                  return (
                    <ActiveMeasureConfigPolyItem
                      key={layer.id}
                      index={i}
                      layer={layer}
                      measure={measureConfiguration.measure}
                      minArea={minArea}
                      measureConfigurations={measureConfigurations}
                      drawState={drawState}
                      basePolygon={basePolygon}
                      removeLayerFromMeasureConfig={
                        removeLayerFromMeasureConfig
                      }
                      updateDrawState={updateDrawState}
                      updateMeasureConfigurations={updateMeasureConfigurations}
                    />
                  );

                return (
                  <ActiveMeasureConfigPointItem
                    key={layer.id}
                    index={i}
                    layer={layer}
                    measure={measureConfiguration.measure}
                    mapRef={mapRef}
                    measureConfigurations={measureConfigurations}
                    basePolygon={basePolygon}
                    removeLayerFromMeasureConfig={removeLayerFromMeasureConfig}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: ${({ theme }) => theme.spacing(2)};
`;
